import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import TitleLogoComponent from "../Misc/TitleLogo/TitleLogoComponent";
import TitleTagsComponent from "../Misc/TitleTags/TitleTagsComponent";
import { getAssetButtonName, truncatedDescription } from "../../../utils/AppUtils";
import Dropdown from "react-bootstrap/Dropdown";
import "./ProductCardComponent.scss";
import FormButtonComponent from "../FormControl/FormButton/FormButtonComponent";
import { RightArrowIcon } from "../../../utils/SvgComps";
import ImageComponent from "../../Layouts/ImageComponent";
import _ from "lodash";
import { useSelector } from "react-redux";
import "./ProductCardComponent.scss"
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
const ProductCardLpDetail = (props) => {

    const {
        id, title, logoAltText, logoURL, bannerURL,
        tagsArray, descAction, description, btnTitle,
        btnAction, bannerAction, footerLineComp, showUpdatedTag,
        showHeader, showBody, showFooter, leftBtnIcon, rightBtnIcon,
        cardClassName, isLoading, progress, duration,
        showProgress, showBtn, isLock, showPlayButton, showProviderIcon, lastKey, refInfo, showLikeMenu, tooltip, is_checklist_approved,
        checklist_approved_by, is_checklist_present, is_learn_more, setShowCL, setCheckListLp, clInfo,asset_type,asset_id,monitoring_name,
        asset_icon,monitoring_icon
    } = props;

    const userDetails = useSelector(state => state.user.userBroker);
    const {t} = useTranslation()
    const renderMainComp = () => {
        return (
            <>

                <div className="modulesection "
                    id={`course-lp-${id}`}
                    title={tooltip}>

                    <h3>{title}</h3>
                    <div className="d-flex box-meta">

                        <div className="img-box-meta">

                            <TitleLogoComponent
                                logoURL={logoURL}
                                altText={""}
                                isLoading={false}
                            />
                        </div>
                        <div className="meta-lsit">
                            <TitleTagsComponent
                                tagsArray={tagsArray}
                                isLoading={isLoading}
                            />
                        </div>
                    </div>
                    <div className="image-blocklp">
                        <ImageComponent
                            thumbnail={
                                bannerURL ? bannerURL : ""
                            }
                            name={title}
                            cssClass={`img-fluid galleryImg ${isLock ? "grayscale" : ""
                                }`}
                            errorClass={`img-fluid grayscale d-flex justify-content-center align-items-center bk-grey ${isLock ? "grayscale" : ""
                                }`}
                            handleClick={bannerAction}
                        />
                        {showUpdatedTag ? <div className="new-tag"><span className="new-tag-ribbon">{t("Updated")}</span></div> : ""}
                        <div className="d-flex justify-content-between align-items-center position-absolute info-btm-pcard">
                        {is_checklist_approved ? <div class="approvedbysec">
                            <div class="fgf">
                                <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(41,45,50,1)"><path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"></path></svg> Approved By: {checklist_approved_by}</p>
                            </div>
                        </div> : is_checklist_present ? <div class="approvedbysec">
                            <div class="fgf">
                                <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(41,45,50,1)"><path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"></path></svg> 
                                {t("Approver:")} {(userDetails?.payload?.payload?.manager && userDetails?.payload?.payload?.manager != ' ') ? userDetails?.payload?.payload?.manager : "Admin"}</p>
                            </div>
                        </div> : ""
                        }
                        {(is_checklist_present) ?
                            <span className={`checklistingo cursor-pointer`} onClick={() => {
                                setShowCL(true);
                                setCheckListLp(clInfo)
                            }} title="Checklist">
                                <img src="/images/checklist.png" width={32} height={32} />
                            </span>
                            : ""}
                    </div>
                    </div>

                    <OverlayTrigger
                        key="bottom"
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-bottom`}>
                                <div
                                    style={{
                                        color: "white",
                                        backgroundColor: "transparent",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                ></div>
                            </Tooltip>
                        }
                    >
                        {description !== undefined ? <p
                            dangerouslySetInnerHTML={{
                                __html:
                                    description?.length <= 170
                                        ? description
                                        : description?.substring(0, 159) + "...",
                            }}
                        ></p> : <p></p>}
                    </OverlayTrigger>
                   

                    <div className="progress-rowsec">
                        {showProgress && <div className="d-flex gap-3 progress-content position-relative">
                            <div className="progress-rowbar">
                                <div
                                    className="progress"
                                    role="progressbar"
                                    aria-label="Basic example"
                                    aria-valuenow={progress}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    <div
                                        className="progress-bar"
                                        style={{ width: progress + "%" }}
                                    ></div>
                                </div>
                            </div>
                            <span className="progress-text">
                                {_.isNumber(progress) ? progress : progress?.split(".")[0]}%
                            </span>
                        </div>}

                        {showBtn && <>
                            <div className="price-sec-xl">
                                {footerLineComp}
                            </div>

                            <button
                                type="button"
                                tabIndex={0}
                                aria-label={btnTitle}
                                className={isLock ? 'locked-btn-b2c' : 'startcourse-btn'}
                                onClick={btnAction}
                            >
                                {isLock && <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <path opacity="0.12" d="M4.5 15.8C4.5 14.1198 4.5 13.2798 4.82698 12.638C5.1146 12.0735 5.57354 11.6146 6.13803 11.327C6.77976 11 7.61984 11 9.3 11H15.7C17.3802 11 18.2202 11 18.862 11.327C19.4265 11.6146 19.8854 12.0735 20.173 12.638C20.5 13.2798 20.5 14.1198 20.5 15.8V16.2C20.5 17.8802 20.5 18.7202 20.173 19.362C19.8854 19.9265 19.4265 20.3854 18.862 20.673C18.2202 21 17.3802 21 15.7 21H9.3C7.61984 21 6.77976 21 6.13803 20.673C5.57354 20.3854 5.1146 19.9265 4.82698 19.362C4.5 18.7202 4.5 17.8802 4.5 16.2V15.8Z" fill="black" />
                                    <path id="lcked" d="M17.5 11V8C17.5 5.23858 15.2614 3 12.5 3C9.73858 3 7.5 5.23858 7.5 8V11M9.3 21H15.7C17.3802 21 18.2202 21 18.862 20.673C19.4265 20.3854 19.8854 19.9265 20.173 19.362C20.5 18.7202 20.5 17.8802 20.5 16.2V15.8C20.5 14.1198 20.5 13.2798 20.173 12.638C19.8854 12.0735 19.4265 11.6146 18.862 11.327C18.2202 11 17.3802 11 15.7 11H9.3C7.61984 11 6.77976 11 6.13803 11.327C5.57354 11.6146 5.1146 12.0735 4.82698 12.638C4.5 13.2798 4.5 14.1198 4.5 15.8V16.2C4.5 17.8802 4.5 18.7202 4.82698 19.362C5.1146 19.9265 5.57354 20.3854 6.13803 20.673C6.77976 21 7.61984 21 9.3 21Z" stroke="#415385" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>}
                                {btnTitle}
                                {!isLock && <RightArrowIcon />}
                            </button>
                        </>}
                    </div>
                </div>







            </>
        )
    }

    return (
        <>
        <div class="card">
                  <h3 
                dangerouslySetInnerHTML={{
                    __html: title
                }}
            >
            </h3>
                  <p dangerouslySetInnerHTML={{
                    __html: description
                }}>
                  </p>
                  <ul>
                    <li><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 0C9.088 0 10.128 0.208 11.12 0.624C12.0693 1.02933 12.912 1.60533 13.648 2.352C14.3947 3.088 14.9707 3.93067 15.376 4.88C15.792 5.872 16 6.912 16 8C16 9.088 15.792 10.128 15.376 11.12C14.9707 12.0693 14.3947 12.912 13.648 13.648C12.912 14.3947 12.0693 14.9707 11.12 15.376C10.128 15.792 9.088 16 8 16C6.912 16 5.872 15.792 4.88 15.376C3.93067 14.9707 3.08267 14.3947 2.336 13.648C1.6 12.912 1.02933 12.0693 0.624 11.12C0.208 10.128 0 9.088 0 8C0 6.912 0.208 5.872 0.624 4.88C1.02933 3.93067 1.6 3.088 2.336 2.352C3.08267 1.60533 3.93067 1.02933 4.88 0.624C5.872 0.208 6.912 0 8 0ZM8 15.008C9.26933 15.008 10.448 14.688 11.536 14.048C12.592 13.4293 13.4293 12.592 14.048 11.536C14.688 10.448 15.008 9.26933 15.008 8C15.008 6.73067 14.688 5.552 14.048 4.464C13.4293 3.408 12.592 2.57067 11.536 1.952C10.448 1.312 9.26933 0.992 8 0.992C6.74133 0.992 5.568 1.312 4.48 1.952C3.424 2.57067 2.58667 3.408 1.968 4.464C1.328 5.552 1.008 6.73067 1.008 8C1.008 9.26933 1.328 10.448 1.968 11.536C2.58667 12.592 3.424 13.4293 4.48 14.048C5.568 14.688 6.74133 15.008 8 15.008ZM8.496 7.504H12.96V8.496H7.504V3.04H8.496V7.504Z"
                        fill="#474747"></path>
                    </svg>{duration}</li>
                    <li  className="ms-1">{asset_icon ?
                        <img src={asset_icon} width="14" height="16" alt="icon" className="icon-cardbox img-fluid"></img> :
                        <svg width="16" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.32801 0L13.68 4.864V16H0.320007V0H9.32801ZM8.49601 0.96H1.28001V15.04H12.72V5.44H8.49601V0.96ZM11.488 6.992L11.6 7.12L11.552 7.184V13.104L11.6 13.152L11.488 13.28L8.54401 10.336V12.8H2.56001V7.472H8.54401V9.936L11.488 6.992ZM9.47201 1.36V4.48H12.24L9.47201 1.36Z"
                        fill="#474747"></path>
                    </svg>} {asset_type}</li>
                    <li  className="ms-1">{monitoring_icon ?
                        <img src={monitoring_icon} width="14" height="16" alt="icon" className="icon-cardbox img-fluid"></img> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3 5.504V7.552C3.01066 7.69067 3.064 7.808 3.16 7.904C3.26666 8 3.38933 8.04267 3.528 8.032C3.66666 8.02133 3.77866 7.968 3.864 7.872C3.96 7.76533 4.00266 7.64267 3.992 7.504V5.44C3.98133 5.30133 3.92266 5.18933 3.816 5.104C3.72 5.01867 3.60266 4.98133 3.464 4.992C3.336 5.00267 3.224 5.056 3.128 5.152C3.04266 5.248 3 5.36533 3 5.504ZM11.992 4.496V6.56C12.0133 6.688 12.072 6.79467 12.168 6.88C12.2747 6.96533 12.392 7.00267 12.52 6.992C12.6587 6.98133 12.7707 6.93333 12.856 6.848C12.9413 6.752 12.9893 6.63467 13 6.496V4.448C12.9893 4.30933 12.9307 4.20267 12.824 4.128C12.7173 4.04267 12.6 4.00533 12.472 4.016C12.344 4.016 12.232 4.064 12.136 4.16C12.0507 4.256 12.0027 4.368 11.992 4.496ZM7.496 3.504V7.552C7.50667 7.69067 7.56533 7.80267 7.672 7.888C7.77866 7.96267 7.896 7.99467 8.024 7.984C8.152 7.97333 8.25867 7.92533 8.344 7.84C8.44 7.744 8.488 7.632 8.488 7.504V3.44C8.46666 3.312 8.408 3.20533 8.312 3.12C8.216 3.03467 8.09866 2.99733 7.96 3.008C7.832 3.01867 7.72 3.072 7.624 3.168C7.53866 3.25333 7.496 3.36533 7.496 3.504ZM6.504 12.992H9.496V15.008H6.504V12.992ZM1.496 12H5.496V15.008H1.496V12ZM10.504 12H14.504V15.008H10.504V12ZM6.504 10.992H9.496V12H6.504V10.992ZM1.496 2.992H5.496V10.992H1.496V2.992ZM10.504 2H14.504V10.992H10.504V2ZM6.504 0.992H9.496V10H6.504V0.992ZM5.928 0C5.81067 0.0213331 5.70933 0.0799996 5.624 0.176C5.53866 0.261333 5.496 0.368 5.496 0.495999V2H0.999998C0.861331 2 0.743998 2.048 0.647998 2.144C0.551998 2.24 0.503998 2.35733 0.503998 2.496V15.504C0.503998 15.6427 0.551998 15.76 0.647998 15.856C0.743998 15.952 0.861331 16 0.999998 16H15C15.1387 16 15.256 15.952 15.352 15.856C15.448 15.76 15.496 15.6427 15.496 15.504V1.424C15.4747 1.30667 15.416 1.20533 15.32 1.12C15.2347 1.03467 15.128 0.992 15 0.992H10.504V0.495999C10.504 0.357333 10.4507 0.24 10.344 0.144C10.248 0.048 10.1307 0 9.992 0H5.928Z"
                        fill="#474747"></path>
                    </svg>} {monitoring_name}</li>
                  </ul>
                  <a class="button cursor-pointer" tabindex={0} aria-label="Start" onClick={()=>{bannerAction();}}>Start {getAssetButtonName(asset_id)}<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.08 7.50374L8.576 1.98374C8.48 1.88774 8.432 1.77041 8.432 1.63174C8.432 1.49308 8.48 1.37574 8.576 1.27974C8.672 1.18374 8.78933 1.13574 8.928 1.13574C9.06667 1.13574 9.184 1.18374 9.28 1.27974L16 7.99974L9.28 14.7197C9.184 14.8157 9.06667 14.8637 8.928 14.8637C8.78933 14.8637 8.672 14.8157 8.576 14.7197C8.48 14.6237 8.432 14.5064 8.432 14.3677C8.432 14.2291 8.48 14.1117 8.576 14.0157L14.08 8.49574H0.496C0.357333 8.49574 0.24 8.44774 0.144 8.35174C0.048 8.25574 0 8.13841 0 7.99974C0 7.86108 0.048 7.74374 0.144 7.64774C0.24 7.55174 0.357333 7.50374 0.496 7.50374H14.08Z"
                      fill="#415385"></path>
                  </svg>
                  </a>
                </div>
        </>
    );
};

export default ProductCardLpDetail;
